import {
  Button,
  ButtonGroup,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import { useCallback, useMemo, useState } from "react";
import { useBuildingRoomMediaPictures } from "../../../graphql/hooks";
import { BuildingMediaType } from "../../../graphql/models/BuildingMedia";
import { LoadWrapper } from "../load_wrapper";
import { AddMediaPaper } from "./add-media-paper";

export type BuildingMediaEditorProps = {
  buildingId: string;
  buildingCode: string;
  onMediaAdd?: (mediaId: string) => void;
  // onMediaDelete?: (deletedMediaId: string) => void;
};

export function BuildingMediaEditor(props: BuildingMediaEditorProps) {
  const { buildingId, buildingCode, onMediaAdd } = props;

  const [mediaType, setMediaType] = useState<"PICTURES" | "ICONS">("PICTURES");

  const buildingMediaType: BuildingMediaType = useMemo(() => {
    switch (mediaType) {
      case "ICONS":
        return BuildingMediaType.ROOM_ICON;
      case "PICTURES":
        return BuildingMediaType.ROOM_PICTURE;
      default:
        return BuildingMediaType.ROOM_PICTURE;
    }
  }, [mediaType]);

  const {
    buildingRoomMediaPictures,
    loading: buildingRoomMediaPicturesLoading,
    refetchBuildingRoomMediaPictures,
  } = useBuildingRoomMediaPictures(buildingId, mediaType);

  const onMediaCreated = useCallback(
    (mediaId: string) => {
      refetchBuildingRoomMediaPictures();
      onMediaAdd && onMediaAdd(mediaId);
    },
    [onMediaAdd, refetchBuildingRoomMediaPictures]
  );

  return (
    <LoadWrapper loading={buildingRoomMediaPicturesLoading}>
      <Paper elevation={3} style={{ width: "100%", padding: "0.5rem" }}>
        <Grid container style={{ width: "100%" }} spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h2">
              Immagini ed icone consigliate per le stanze
            </Typography>
            <Typography variant="caption">
              Queste immagini verranno proposte in-app nella sezione "immagini
              predefinite" per consentire agli utenti di scegliere un'immagine
              tra quelle consigliate.
            </Typography>
          </Grid>
          <Grid
            container
            xs={12}
            alignItems="center"
            justify="center"
            style={{
              width: "100%",
              padding: "1rem",
            }}
          >
            <ButtonGroup disableRipple variant="contained" color="secondary">
              <Button
                variant={mediaType === "PICTURES" ? "contained" : "outlined"}
                onClick={() => setMediaType("PICTURES")}
              >
                Immagini
              </Button>
              <Button
                variant={mediaType === "ICONS" ? "contained" : "outlined"}
                onClick={() => setMediaType("ICONS")}
              >
                Icone
              </Button>
            </ButtonGroup>
          </Grid>
          {buildingRoomMediaPictures?.map((buildingMedia) => (
            <Grid key={buildingMedia.id} item>
              <Paper
                elevation={5}
                style={{ width: 179, height: 160, padding: "0.5rem" }}
              >
                <img
                  style={{ width: 159, height: 116 }}
                  alt={buildingMedia.mediaType.toString()}
                  src={buildingMedia.image.url}
                />
                {/* <ConfirmButtonWithDialog
                  dialogContent={
                    "Confermi di voler eliminare questa immagine? Gli utenti che l'hanno selezionata non potranno più vedere questa immagine."
                  }
                  onConfirm={() => triggerDeleteMedia(buildingMedia.id)}
                  onUndo={() => void 0}
                  dialogProps={{
                    fullScreen: false,
                    title: "Eliminazione immagine",
                  }}
                >
                  ELIMINA
                </ConfirmButtonWithDialog> */}
              </Paper>
            </Grid>
          ))}
          <Grid key={"new-building-media-item"} item>
            <AddMediaPaper
              buildingId={buildingId}
              buildingCode={buildingCode}
              buildingMediaType={buildingMediaType}
              onMediaCreated={onMediaCreated}
            />
          </Grid>
        </Grid>
      </Paper>
    </LoadWrapper>
  );
}
